// 공용 로딩 인디케이터 — 프로젝트 전반 재사용용(기존엔 각 화면이 인라인 animate-spin을 제각각 사용).
//  - Spinner: 버튼/행/셀 안에 넣는 인라인 스피너.
//  - LoadingOverlay: 화면 중앙에 카드형으로 뜨는 로딩 오버레이(비동기 작업 진행 알림, 예: AI 정제 딜레이).
import type { ReactNode } from 'react';

/** 인라인 스피너 — size(px)로 크기 조절. 버튼/행 등 인라인 맥락용. */
export function Spinner({
  size = 16,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      role="status"
      aria-label="로딩 중"
      className={`inline-block shrink-0 animate-spin rounded-full border-2 border-gray-300 border-t-brand-600 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

/**
 * 화면 중앙 로딩 오버레이(카드형). `fixed` 배치라 어느 컨테이너에 넣어도 화면 중앙에 뜬다.
 *  - blocking=false(기본): backdrop이 pointer-events-none이라 화면을 막지 않는다(백그라운드 재조회 등).
 *  - blocking=true: backdrop이 클릭을 흡수(작업 완료까지 조작 차단).
 * z-[80]은 모달(root z-[70]) 위. label로 진행 상황 문구를 준다.
 */
export function LoadingOverlay({
  label,
  blocking = false,
}: {
  label?: ReactNode;
  blocking?: boolean;
}) {
  return (
    <div
      className={`fixed inset-0 z-[80] flex items-center justify-center bg-black/10 ${
        blocking ? '' : 'pointer-events-none'
      }`}
      role="status"
      aria-live="polite"
    >
      {/* eslint-disable-next-line local/no-self-painted-card -- 오버레이 위에 떠 있는 토스트 패널(팝오버 갈래). 테두리 없이 ring+shadow-xl로 부유감을 내고 좌우/상하 여백이 비대칭(px-5 py-3)이라 Card 축에 맞지 않는다. */}
      <div className="pointer-events-auto flex items-center gap-3 rounded-card bg-white px-5 py-3 shadow-xl ring-1 ring-black/5">
        <Spinner size={22} />
        {label && <span className="text-sm font-medium text-gray-700">{label}</span>}
      </div>
    </div>
  );
}
